export const ignitionOnThreshold = 30 * 60 * 1000 // 30 minutes in milliseconds
export const lowerTemperatureThresholdDegreesCelsius = 18
export const upperTemperatureThresholdDegreesCelsius = 30
